"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradesWebSocket = void 0;
const rxjs_1 = require("rxjs");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class TradesWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.tradeCacheData = new CacheData_1.CacheData([], new rxjs_1.BehaviorSubject([]));
        this.tradePairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.trade, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.trade, param);
        });
        this.maxCount = 20;
    }
    handleTradeData(pushData) {
        const data = pushData.map((item) => ({
            base: item.b,
            quote: item.q,
            symobol: item.b.toUpperCase() + "/" + item.q.toUpperCase(),
            side: item.d,
            timestamp: item.t,
            price: Number(item.p),
            amount: Number(item.a),
            fee: 0,
            order: "",
            id: "",
            buyerMaker: false,
            symbol: "",
        }));
        if (data.length > 0) {
            const sortedData = data.sort((a, b) => b.timestamp - a.timestamp);
            let newData = this.tradeCacheData.getCacheData();
            newData.unshift(...sortedData);
            if (newData.length > this.maxCount) {
                newData = newData.slice(0, this.maxCount);
                this.tradeCacheData.updateCache(newData);
            }
            else {
                this.tradeCacheData.updateCache(newData);
            }
        }
    }
    /**
     * 订阅Trades(最新成交记录)推送
     * [{
     *    exchange: "pionex.v2",
     *    base: base,
     *    quote: quote,
     * }]
     * @param exchange
     * @param base
     * @param quote
     */
    getTradesObservable(exchange, base, quote, maxCount = 20) {
        this.tradePairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote }]);
        // 暂时同一时间只支持订阅一个交易对
        this.tradeCacheData.updateCache([]);
        this.maxCount = maxCount;
        return new rxjs_1.Observable((observer) => {
            const subscription = this.tradeCacheData.getDataSubject().subscribe((result) => {
                observer.next(result);
            }, (err) => { });
            observer.add(() => {
                subscription.unsubscribe();
                this.tradePairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                    },
                ]);
            });
        });
    }
}
exports.TradesWebSocket = TradesWebSocket;
